export default function () {
    return {
        KEYS: {
            QUEUED: 'QUEUED',
            RUNNING: 'RUNNING',
            FINISHED: 'FINISHED',
            FAILED: 'FAILED'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/automated/planning/group/generationStatus/index.js